"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceItemControl = exports.ChoiceItemContainer = void 0;
const theme_1 = require("@pulse-web-ui/theme");
exports.ChoiceItemContainer = theme_1.styled.div `
  position: relative;
  height: 20px;
  padding: 0px 22px 0px 4px;
  background-color: ${({ theme, isFocused }) => isFocused ? theme.colors.neutral[10] : 'white'};
  border-radius: ${({ theme }) => theme.common.radius};
  ${theme_1.typography.regular14};
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.text.primary};
  display: inline-block;
  margin-right: 2px;
`;
exports.ChoiceItemControl = theme_1.styled.div `
  position: absolute;
  right: 4px;
  top: 2px;
`;
